module.exports = {"data":{"markdownRemark":{"html":"<p>WIP: This page will describe how to install the Progressive Web Apps for the platforms that support them, giving the most native-like user experience.</p>","frontmatter":{"path":"/SF2PWA","title":"Progressive Web App Features","summary":"How to install the SubFire PWAs"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/sf-2-pwa.json
// module id = 389
// module chunks = 2888652111644